/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class ExportsService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'ExportsService\' loaded');
    }

    /**
     * Generate exports.
     *
     * @param {String} type Type of export.
     * @param {Object} data Data sent in the request body.
     * @returns {Promise} A promise providing the id of the file generated.
     */
    generateExports(type, data) {
        return this.resource.generateExports({type}, data).$promise;
    }

    /**
     * Generate exports.
     *
     * @param {String} fileId Id of the export.
     * @returns {Promise} A promise providing the status of the export.
     */
    getExportsStatus(fileId) {
        return this.resource.getExportsStatus({fileId}).$promise;
    }
}

export { ExportsService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/exports/service/ExportsService.js